import AddCompanyModal from "./AddCompanyModal";

export default AddCompanyModal;
